<template>
  <section class="page-card">
    <h1 class="page-title">{{ $t('pages.agentRechargeOrders') }}</h1>
    <div class="filter-bar">
      <el-input v-model="search.order_no" :placeholder="$t('common.orderId')" class="filter-item" size="small"></el-input>
      <el-select v-model="search.status" clearable :placeholder="$t('common.status')" class="filter-item" size="small">
        <el-option v-for="item in eadStatuses" :key="item.value" :value="item.value" :label="$t(item.labelKey)"></el-option>
      </el-select>
      <el-select v-model="search.wallet_recorded" clearable :placeholder="$t('common.walletRecorded')" class="filter-item" size="small">
        <el-option value="1" :label="$t('common.yes')"></el-option>
        <el-option value="0" :label="$t('common.no')"></el-option>
      </el-select>
      <el-date-picker v-model="search.created_at__gte" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.start')" class="filter-item"></el-date-picker>
      <el-date-picker v-model="search.created_at__lt" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.end')" class="filter-item"></el-date-picker>
      <el-button type="primary" size="small" @click="reload">{{ $t('actions.search') }}</el-button>
    </div>

    <div class="table-scroll">
      <el-table :key="tableLanguage" :data="tableData" border stripe>
        <el-table-column prop="order_no" :label="$t('common.orderId')" min-width="180"></el-table-column>
        <el-table-column prop="third_no" :label="$t('common.thirdOrderNo')" min-width="170"></el-table-column>
        <el-table-column prop="amount" :label="$t('common.amount')" min-width="100"></el-table-column>
        <el-table-column prop="actual_amount" :label="$t('common.actualAmount')" min-width="120"></el-table-column>
        <el-table-column prop="currency_code" :label="$t('common.currency')" min-width="90"></el-table-column>
        <el-table-column :label="$t('common.status')" min-width="120">
          <template slot-scope="scope">{{ statusText(scope.row.status) }}</template>
        </el-table-column>
        <el-table-column :label="$t('common.walletRecorded')" min-width="120">
          <template slot-scope="scope">{{ scope.row.wallet_recorded ? $t('common.yes') : $t('common.no') }}</template>
        </el-table-column>
        <el-table-column prop="fail_reason" :label="$t('common.failReason')" min-width="180"></el-table-column>
        <el-table-column prop="created_at" :label="$t('common.createdAt')" min-width="165"></el-table-column>
        <el-table-column prop="updated_at" :label="$t('common.updatedAt')" min-width="165"></el-table-column>
        <el-table-column :label="$t('common.actions')" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showDetail(scope.row)">{{ $t('actions.detail') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :total="count"
      :current-page.sync="search.page"
      :page-size="search.size"
      layout="total, prev, pager, next"
      @current-change="loadData"
    ></el-pagination>

    <el-dialog :title="$t('pages.agentRechargeOrderDetail')" :visible.sync="detailVisible" width="620px">
      <el-descriptions v-if="detail" :column="2" border>
        <el-descriptions-item :label="$t('common.orderId')">{{ detail.order_no || '-' }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.thirdOrderNo')">{{ detail.third_no || '-' }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.amount')">{{ detail.amount || '0' }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.actualAmount')">{{ detail.actual_amount || '0' }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.currency')">{{ detail.currency_code || '-' }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.status')">{{ statusText(detail.status) }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.walletRecorded')">{{ detail.wallet_recorded ? $t('common.yes') : $t('common.no') }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.failReason')" :span="2">{{ detail.fail_reason || '-' }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.createdAt')">{{ detail.created_at || '-' }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.updatedAt')">{{ detail.updated_at || '-' }}</el-descriptions-item>
        <el-descriptions-item :label="$t('common.walletRecordedAt')" :span="2">{{ detail.wallet_recorded_at || '-' }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: 'AgentRechargeOrders',
  data() {
    return {
      search: {
        page: 1,
        size: 20,
        order_no: '',
        status: '',
        wallet_recorded: '',
        created_at__gte: '',
        created_at__lt: ''
      },
      tableData: [],
      count: 0,
      detail: null,
      detailVisible: false,
      eadStatuses: [
        { value: 0, labelKey: 'eadStatus.ready' },
        { value: 1, labelKey: 'eadStatus.success' },
        { value: 2, labelKey: 'eadStatus.failed' },
        { value: 3, labelKey: 'eadStatus.processing' }
      ]
    };
  },
  computed: {
    tableLanguage() {
      return this.$i18nState.language;
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    reload() {
      this.search.page = 1;
      this.loadData();
    },
    buildQueryParams() {
      return Object.keys(this.search).reduce((params, key) => {
        const value = this.search[key];
        if (value !== '' && value !== null && value !== undefined) params[key] = value;
        return params;
      }, {});
    },
    statusText(status) {
      this.tableLanguage;
      const item = this.eadStatuses.find(one => String(one.value) === String(status));
      return item ? this.$t(item.labelKey) : (status === '' || status === null ? '-' : status);
    },
    async loadData() {
      const resp = await this.$axios.get('/admin/exagent/console/funds/recharge/orders/', {
        params: this.buildQueryParams()
      });
      if (resp.data.status !== 0) return;
      const data = resp.data.data || {};
      this.tableData = data.list || [];
      this.count = data.count || 0;
    },
    async showDetail(row) {
      const resp = await this.$axios.get('/admin/exagent/console/funds/recharge/orders/detail/', {
        params: { id: row.id }
      });
      if (resp.data.status !== 0) return;
      this.detail = resp.data.data || {};
      this.detailVisible = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/AgentRechargeOrders.vue